import GenericDeleteModal from "components/GenericDeleteModal";
import { CoreContext } from "context/CoreContext";
import { useContext, useEffect } from "react";
import { ThemedComponent } from "ui/theme";
import ModalAddDelivery from "./AddDelivery";
import ModalAddUser from "./AddUser";
import ModalApproveScript from "./ApproveScript";
import ModalCancelCampaign from "./CancelCampaign";
import ModalChat from "./Chat";
import ModalCookies from "./Cookies";
import ModalCreators from "./Creators";
import ModalDeleteCampaign from "./DeleteCampaign";
import ModalDeleteCreator from "./DeleteCreator";
import ModalDeleteDelivery from "./DeleteDelivery";
import ModalDeletePosts from "./DeletePosts";
import ModalDeleteScript from "./DeleteScript";
import ModalDeleteUser from "./DeleteUser";
import ModalDetailCreator from "./DetailCreator";
import ModalEditUser from "./EditUser";
import ModalFilterCampaign from "./FilterCampaign";
import ModalMedia from "./Media";
import ModalPosts from "./Posts";
import ModalReproveScript from "./ReproveScript";
import ModalReviewApprove from "./ReviewApprove";
import ModalSchedule from "./Schedule";
import ModalScript from "./Script";
import ModalTerms from "./Terms";
import ModalFinish from "./Finish";
import ModalRestart from "./Restart";
import ModalCampaignStatusLogs from "./CampaignStatusLogs";

export default function ModalController() {
  const { modal } = useContext(CoreContext);

  useEffect(() => {
    if (modal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [modal]);

  return (
    <>
      <ThemedComponent>
        {modal?.type === "filter-campaign" ? <ModalFilterCampaign /> : null}
        {modal?.type === "review" ? <ModalReviewApprove /> : null}
        {modal?.type === "terms" ? <ModalTerms /> : null}
        {modal?.type === "cookies" ? <ModalCookies /> : null}
        {modal?.type === "creators" ? <ModalCreators /> : null}
        {modal?.type === "posts" ? <ModalPosts /> : null}
        {modal?.type === "delete-creator" ? <ModalDeleteCreator /> : null}
        {modal?.type === "delete-campaign" ? <ModalDeleteCampaign /> : null}
        {modal?.type === "cancel-campaign" ? <ModalCancelCampaign /> : null}
        {modal?.type === "finish-campaign" ? <ModalFinish /> : null}
        {modal?.type === "campaign-status-logs" ? <ModalCampaignStatusLogs /> : null}
        {modal?.type === "restart-campaign" ? <ModalRestart /> : null}
        {modal?.type === "detail-creator" ? <ModalDetailCreator /> : null}
        {modal?.type === "add-script" ? <ModalScript /> : null}
        {modal?.type === "add-schedule" ? <ModalSchedule /> : null}
        {modal?.type === "delete-script" ? <ModalDeleteScript /> : null}
        {modal?.type === "delete-post" ? <ModalDeletePosts /> : null}
        {modal?.type === "approve-script" ? <ModalApproveScript /> : null}
        {modal?.type === "reprove-script" ? <ModalReproveScript /> : null}
        {modal?.type === "add-delivery" ? <ModalAddDelivery /> : null}
        {modal?.type === "delete-delivery" ? <ModalDeleteDelivery /> : null}
        {modal?.type === "chat" ? <ModalChat /> : null}
        {modal?.type === "delete-user" ? <ModalDeleteUser /> : null}
        {modal?.type === "add-user" ? <ModalAddUser /> : null}
        {modal?.type === "edit-user" ? <ModalEditUser /> : null}
        {modal?.type === "media" ? <ModalMedia /> : null}
        {modal?.type === "delete" ? <GenericDeleteModal /> : null}
      </ThemedComponent>
    </>
  );
}
